@if (!editableImage()) {
    @let image = form?.image().value() ?? null;
    @let resizeType = form?.resizeType().value();

    @let isDeviceMobile = isDeviceMobile$ | async;
    @let isDeviceTablet = isDeviceTablet$ | async;

    <web-widget-breadcrumbs
        [widget]="$any(form?.value())"
        [hideBreadcrumbs]="isZero()"
        [isInSpecificSection]="isSpecific()"
    />
    <div class="panel-options-body overflow-wrapper">
        <div class="form form-horizontal">
            <div [class.mb-20]="image">
                <sp-file-manager
                    [fmSourceType]="fmSourceType.LANDING"
                    [file]="image"
                    [displayOnly]="[DirectoryItemCategory.Image]"
                    (setFileEvent)="setImage($event)"
                    (replaceFileEvent)="replaceImage($event)"
                >
                    @if (!image) {
                        <sp-defautl-upload-button
                            stockImagesDropdown
                            [disabled]="buttonDisabled()"
                            (unsplashRequested)="openUnsplashModal()"
                        />
                    }
                    <ng-template
                        #previewTemplate
                        let-file="file"
                        let-replaceFileFn="replaceFileFn"
                        let-buildFilePreviewUrlsFn="buildFilePreviewUrlsFn"
                    >
                        <div class="mb-20">
                            <sp-files-select
                                #ref
                                toggless
                                (myPhotosClick)="replaceFileFn()"
                                (unsplashClick)="openUnsplashModal()"
                            >
                                <sp-control-handle
                                    [controlHandleImagePreviewSources]="buildFilePreviewUrlsFn(file)"
                                    [controlHandleMainText]="file.name"
                                    [controlHandleSubText]="
                                        image?.imageWidth?.toString() + 'x' + image?.imageHeight.toString() + 'px'
                                    "
                                    (editActionEvent)="editImage(file)"
                                    (removeActionEvent)="removeFile()"
                                    (replaceActionEvent)="ref.dp.toggle()"
                                    (imageEditEvent)="showEditImageModal()"
                                    [isDisableEditor]="(userId$ | async) !== imageOwnerUserId()"
                                />
                            </sp-files-select>
                        </div>
                    </ng-template>
                </sp-file-manager>
            </div>
            @if (image) {
                @let sync = form.isSynchronizeStyle().value();
                @let halign = form.horizontalAlign().value();
                @let mhalign = form.mobileHorizontalAlign().value();
                @let thalign = form.tabletHorizontalAlign().value() ?? mhalign ?? halign;

                @if (!isSpecific()) {
                    <div class="form-group mb-20">
                        <label class="col-xs-12">
                            {{ "control_appearance" | translate }}
                        </label>
                        <div class="col-xs-12">
                            <div class="btn-group d-flex">
                                <div
                                    class="btn btn-grey w-100"
                                    [class.active]="!resizeType || resizeType === EResizeType.scale"
                                    (click)="setResizeType(EResizeType.scale)"
                                >
                                    {{ "image_scale" | translate }}
                                </div>
                                <div
                                    class="btn btn-grey w-100"
                                    [class.active]="resizeType === EResizeType.fill"
                                    (click)="setResizeType(EResizeType.fill)"
                                >
                                    {{ "image_fill" | translate }}
                                </div>
                            </div>
                        </div>
                    </div>
                }
                @if (isZero() && isAspectRatioChanged()) {
                    <div class="form-group" style="margin-top: -10px">
                        <div class="col-xs-12">
                            <a (click)="resetProportion()">
                                <span class="sp-icon icon-refresh"> </span>
                                {{ "image_reset_proportion" | translate }}
                            </a>
                        </div>
                    </div>
                }
                @if (resizeType === EResizeType.fill && isZero()) {
                    <div class="form-group row mb-15 form-horizontal">
                        <label class="col-xs-5 control-label">
                            {{ "background_settings_position" | translate }}
                        </label>
                        <div class="col-xs-7">
                            <select class="form-control" [formField]="zeroForm.imagePosition">
                                @for (option of backgroundPositionOptions; track option) {
                                    <option [value]="option.value">
                                        {{ option.label | translate }}
                                    </option>
                                }
                            </select>
                        </div>
                    </div>
                }

                <div class="form-row">
                    @if ((!resizeType || resizeType === EResizeType.scale) && !isZero()) {
                        <div class="form-group mb-20">
                            <label class="col-xs-6 control-label">
                                {{ "control_width" | translate }}
                                <small [tooltip]="imageWidth" class="sp-icon icon-info-bold color-light"> </small>
                                <ng-template #imageWidth>
                                    {{ "img_control_max_width" | translate }}
                                </ng-template>
                            </label>
                            <div class="col-xs-6 img-width-control">
                                <img
                                    class="refresh-width-btn"
                                    src="./assets/img/websites/lpc-return-icon.svg"
                                    alt="refresh-icon"
                                    [tooltip]="refreshImageWidthTooltip"
                                    (click)="refreshImageWidth()"
                                />
                                <ng-template #refreshImageWidthTooltip>
                                    {{ "refresh_width_tooltip" | translate }}
                                </ng-template>
                                <sp-input-num
                                    suffixText="px"
                                    [min]="1"
                                    [max]="image?.imageWidth < columnWidth() ? image?.imageWidth : columnWidth()"
                                    [value]="form.maxWidth().value() ?? 0"
                                    (valueChange)="form.setMaxWidth($event)"
                                />
                            </div>
                        </div>
                    }

                    @let isBorder = form.isBorder().value();
                    <div class="form-group" [class.mb-20]="!isBorder" [class.mb-10]="isBorder">
                        <label class="col-xs-9 control-label">
                            {{ "control_contour" | translate }}
                        </label>
                        <div class="col-xs-3 text-right">
                            <sp-switch [active]="isBorder" (toggleActiveEvent)="form.setIsBorder($event)" />
                        </div>
                    </div>

                    @if (isBorder) {
                        <sp-advanced-border-settings-signal-legacy
                            [borderSettings]="advancedBorderSettings()"
                            (valueChangeEvent)="setAdvancedBorderSettings($event)"
                        />
                    }

                    @let isShadow = form.isShadow?.()?.value();
                    <div class="form-group" [class.mb-20]="!isShadow" [class.mb-10]="isShadow">
                        <label class="col-xs-9 control-label">
                            {{ "control_shadow" | translate }}
                        </label>
                        <div class="col-xs-3 text-right">
                            <sp-switch [active]="isShadow" (toggleActiveEvent)="form.setIsShadow($event)"></sp-switch>
                        </div>
                    </div>

                    @if (isShadow) {
                        <sp-shadow-settings-signal-legacy
                            [shadowSettings]="shadowSettings()"
                            (valueChangeEvent)="form.setShadowSettings($event)"
                        />
                    }

                    @let isIndependentCorners = form.isIndependentCorners().value();
                    <div class="form-group" [class.mb-10]="isIndependentCorners" [class.mb-20]="!isIndependentCorners">
                        <label class="col-xs-6 control-label">
                            {{ "control_radius" | translate }}
                        </label>
                        <div class="col-xs-6 custom-corner-wrapper">
                            <button
                                [tooltip]="'control_custom_radius_toolip' | translate"
                                placement="top"
                                class="btn btn-action btn-custom-corner"
                                [class.active]="isIndependentCorners"
                                (click)="toggleIndependentCorners()"
                            >
                                <img src="./assets/img/websites/lpc-corner-icon.svg" />
                            </button>
                            @if (isIndependentCorners) {
                                <div class="custom-corner-input">
                                    <div class="input-group">
                                        <input class="form-control" value="Mix" disabled />
                                        <div class="input-group-addon">px</div>
                                    </div>
                                </div>
                            }
                            @if (!isIndependentCorners) {
                                <sp-input-num
                                    class="custom-corner-input"
                                    suffixText="px"
                                    [min]="borderRadiusBounds.min"
                                    [max]="borderRadiusBounds.max"
                                    [value]="form.borderTopLeftRadius().value() ?? 0"
                                    (valueChange)="setBorderRadius($event)"
                                />
                            }
                        </div>
                    </div>
                    @if (isIndependentCorners) {
                        <div class="form-row mb-20">
                            <sp-advanced-radius-settings
                                [radiusSettings]="radiusSettings()"
                                (valueChangeEvent)="setAdvancedRadiusSettings($event)"
                            />
                        </div>
                    }
                    <div class="form-group mb-10">
                        <div class="col-xs-12 device-toggle-wrapper">
                            <web-device-toggle />
                            @if (!isZero()) {
                                <web-synchronize-style-toggle [active]="sync" (click)="setSynchronizeStyle()" />
                            }
                        </div>
                    </div>
                    @if (isDeviceDesktop$ | async) {
                        <div class="form-group mb-0">
                            <p class="col-xs-12 help-block text-muted small">
                                {{ "desktop_device_hint" | translate }}
                            </p>
                        </div>
                        <ng-container *ngTemplateOutlet="desktopSettings"> </ng-container>
                    }
                    @if (isDeviceTablet) {
                        <div class="form-group mb-0">
                            <p class="col-xs-12 help-block text-muted small">
                                {{ "tablet_device_hint" | translate }}
                            </p>
                        </div>
                        @if (!isZero()) {
                            <div class="mb-20">
                                <div class="form-group">
                                    <label class="control-label col-xs-7">
                                        {{ "control_content_alignment" | translate }}
                                    </label>
                                    <div class="col-xs-5">
                                        @if (sync) {
                                            <sp-radio-group
                                                [selected]="$any(halign)"
                                                [type]="ERadioGroupType.horizontalPosition"
                                                (changeSelectedEvent)="setHorizontalAlign($event)"
                                            />
                                        } @else {
                                            <sp-radio-group
                                                [selected]="$any(thalign)"
                                                [type]="ERadioGroupType.horizontalPosition"
                                                (changeSelectedEvent)="setTabletHorizontalAlign($event)"
                                            />
                                        }
                                    </div>
                                </div>
                            </div>
                        }
                    }
                    @if (isDeviceMobile) {
                        <div class="form-group mb-0">
                            @if (isZero()) {
                                <p class="col-xs-12 help-block text-muted small">
                                    {{ "mobile_zero_device_hint" | translate }}
                                </p>
                            }
                            @if (!isZero()) {
                                <p class="col-xs-12 help-block text-muted small">
                                    {{ "mobile_device_hint" | translate }}
                                </p>
                            }
                        </div>
                        @if (sync) {
                            @if (!isZero()) {
                                <div class="mb-20">
                                    <div class="form-group">
                                        <label class="control-label col-xs-7">
                                            {{ "control_content_alignment" | translate }}
                                        </label>
                                        <div class="col-xs-5">
                                            <sp-radio-group
                                                [selected]="$any(halign)"
                                                [type]="ERadioGroupType.horizontalPosition"
                                                (changeSelectedEvent)="setHorizontalAlign($event)"
                                            />
                                        </div>
                                    </div>
                                </div>
                            }
                        } @else {
                            @if (!isZero()) {
                                <div class="mb-20">
                                    <div class="form-group">
                                        <label class="control-label col-xs-7">
                                            {{ "control_content_alignment" | translate }}
                                        </label>
                                        <div class="col-xs-5">
                                            <sp-radio-group
                                                [selected]="$any(mhalign)"
                                                [type]="ERadioGroupType.horizontalPosition"
                                                (changeSelectedEvent)="setMobileHorizontalAlign($event)"
                                            />
                                        </div>
                                    </div>
                                </div>
                            }
                        }
                    }
                    <ng-template #desktopSettings>
                        @if (!isZero()) {
                            <div class="mb-20">
                                <div class="form-group">
                                    <label class="control-label col-xs-7">
                                        {{ "control_content_alignment" | translate }}
                                    </label>
                                    <div class="col-xs-5">
                                        <sp-radio-group
                                            [selected]="$any(halign)"
                                            [type]="ERadioGroupType.horizontalPosition"
                                            (changeSelectedEvent)="setHorizontalAlign($event)"
                                        />
                                    </div>
                                </div>
                            </div>
                        }
                    </ng-template>
                </div>
                @if (isZero()) {
                    <sp-extended-position-signal-settings
                        [position]="zeroPosition()"
                        [showHeight]="true"
                        [showWidth]="true"
                        [isMobile]="isDeviceMobile"
                        [isTablet]="isDeviceTablet"
                        [parentId]="form.columnId().value()"
                        [keepSizeProportions]="resizeType === EResizeType.scale"
                        (valueChangeEvent)="zeroForm.setPosition($event)"
                    />
                } @else {
                    <web-widget-position-settings
                        [isSynchronized]="sync"
                        [isTablet]="isDeviceTablet"
                        [isMobile]="isDeviceMobile"
                        [widgetId]="widget().id"
                        [columnId]="form.columnId().value()"
                        [position]="defaultForm.position?.()?.value() ?? null"
                        (positionChange)="defaultForm.setPosition($any($event))"
                    />
                }
                <div class="form-group mb-0">
                    <div class="col-xs-12">
                        <hr class="panel-options-divider" />
                    </div>
                </div>
                @if (isZero()) {
                    <web-widget-extended-hide-settings
                        [hideOnDesktop]="form.hideOnDesktop().value()"
                        [hideOnTablet]="form.hideOnTablet().value()"
                        [hideOnMobile]="form.hideOnMobile().value()"
                        (hideOnDesktopChange)="form.setHideOnDesktop($event)"
                        (hideOnTabletChange)="form.setHideOnTablet($event)"
                        (hideOnMobileChange)="form.setHideOnMobile($event)"
                    />
                } @else {
                    <web-widget-hide-settings
                        [hideOnDesktop]="form.hideOnDesktop().value()"
                        [hideOnTablet]="form.hideOnTablet().value()"
                        [hideOnMobile]="form.hideOnMobile().value()"
                        (hideOnDesktopChange)="form.setHideOnDesktop($event)"
                        (hideOnTabletChange)="form.setHideOnTablet($event)"
                        (hideOnMobileChange)="form.setHideOnMobile($event)"
                    />
                }
                <div class="form-group mb-0">
                    <div class="col-xs-12">
                        <hr class="panel-options-divider" />
                    </div>
                </div>
                <div class="form-row">
                    <sp-animation-settings-signal-legacy
                        [animation]="form.animation().value()"
                        (valueChangeEvent)="form.setAnimation($event)"
                    />
                </div>
                <div class="mt-20">
                    <web-custom-id [displayId]="form.displayId()" (valueChangeEvent)="form.setDisplayId($event)" />
                </div>
            }
        </div>
    </div>
} @else {
    <web-image-settings [form]="form" (saveEvent)="editImage(null)" (cancelEvent)="cancelImageSettings()" />
}
